<app-header></app-header>

<!-- Hero section -->
<div class="section-xl bg-gradient-4">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8">
                <h1 class="fw-semi-bold font-family-syne display-5">We're More Than an <span class="color-black fw-light">IT Company We're Your Strategic Partner in Navigating the Digital Landscape</span> with Confidence.</h1>
                <a class="button-text-3 mt-3 font-family-syne" routerLink="/contact">Get in Touch</a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Hero section -->

<!-- About section -->
<div class="container">
    <div class="n-margin-6">
        <div class="row g-3 g-lg-4">
            <div class="col-12 col-lg-4" *ngFor="let item of aboutItems;">
                <div class="hoverbox-4 bottom border-radius">
                    <img [src]="item.image" [alt]="item.alt">
                    <div class="content">
                        <h5 class="font-family-syne">{{ item.title }}</h5>
                        <p>{{ item.description }}</p>
                    </div>
                    <div class="hover-content">
                        <a class="button button-md button-radius button-outline-white" routerLink="/services">Our Services</a>
                    </div>
                </div>
            </div>
        </div><!-- end row -->
    </div>
</div><!-- end container -->
<!-- end About section -->

<!-- Accordion/Counters section -->
<div class="section">
    <div class="container">
        <div class="row g-5 align-items-center">
            <div class="col-12 col-lg-7">
                <div class="accordion accordion-flush" id="businessAccordion">
                    <div class="accordion-item" *ngFor="let item of accordionItems; let i = index">
                        <h2 class="accordion-header" [id]="'heading' + i">
                            <button class="accordion-button fw-medium font-family-syne" type="button" data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse' + i" [class.collapsed]="!item.open" [attr.aria-expanded]="item.open"
                                [attr.aria-controls]="'collapse' + i">
                                {{ item.title }}
                            </button>
                        </h2>
                
                        <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="item.open"
                            data-bs-parent="#businessAccordion" [attr.aria-labelledby]="'heading' + i">
                            <div class="accordion-body">
                                <p>{{ item.content }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-5">
                <div class="row g-4">
                    <div class="col-6 col-sm-4 col-md-6" *ngFor="let fact of funFacts">
                        <h2 class="display-6 fw-normal m-0 font-family-syne"><span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span>+</h2>
                        <h6 class="font-small fw-medium font-family-syne text-dark-05">{{fact.desc}}</h6>
                    </div>
                    
                    <div class="col-12">
                        <div *ngFor="let skill of skills" class="progress-box mt-4">
                            <h6 class="fw-medium font-family-syne">{{ skill.name }}</h6>
                            <div class="animated-progress">
                                <div [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
                            </div>
                        </div>
                    </div>
                </div><!-- end row(inner) -->
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Accordion/Counters section -->

<!-- Clients section -->
<div class="container">
    <div class="bg-gray-lighter p-4 p-lg-5 border-radius">
        <div class="row g-4 align-items-center">
            <div class="col-12 col-lg-5 col-xxl-4">
                <div class="d-flex align-items-center">
                    <ul class="avatar-group">
                        <li>
                            <img src="assets/images/testimonials/client-1-sm.jpg" alt="client-1">
                        </li>
                        <li>
                            <img src="assets/images/testimonials/client-2-sm.jpg" alt="client-2">
                        </li>
                        <li>
                            <img src="assets/images/testimonials/client-3-sm.jpg" alt="client-3">
                        </li>
                    </ul>
                    <div class="d-inline-block ps-3">
                        <p>We've over 3,000 clients <br class="d-md-block">around the world</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-7 col-xxl-8">
                <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
                    <ng-template carouselSlide *ngFor="let brand of brands">
                        <div class="client-box">
                            <a routerLink="/">
                                <img [src]="brand.image" [alt]="brand.alt">
                            </a>
                        </div>
                    </ng-template>
                </owl-carousel-o><!-- end owl-carousel -->
            </div>
        </div><!-- end row -->
    </div>
</div><!-- end container -->
<!-- end Clients section -->

<!-- Services section -->
<div class="section">
    <div class="container">
        <div class="mb-5">
            <div class="row g-4">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="display-6 font-family-syne fw-light m-0">We integrate staregy, creativity & experience to build brands</h2>
                </div>
            </div><!-- end row -->
        </div>
        <div class="row g-4 icon-5xl">
            <div class="col-12 col-lg-4" *ngFor="let service of services">
                <div class="border border-radius p-4 p-lg-5 hover-shadow">
                    <i class="bi" [ngClass]="service.icon + ' text-dark'"></i>
                    <h5 class="fw-medium mt-2 font-family-syne">
                        {{ service.title }}
                    </h5>
                    <p>{{ service.description }}</p>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Testimonial section -->
<div class="section pt-0">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
            <ng-template carouselSlide *ngFor="let slide of slideStore">
                <!-- Testimonial box -->
                 <div class="testimonial-box">
                    <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
                    <h5 class="fw-normal line-height-140 m-0 font-family-syne">{{slide.title}}</h5>
                    <span class="font-small fw-normal">{{slide.subtitle}}</span>
                    <p class="mt-3">{{slide.desc}}</p>
                </div>
            </ng-template>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg');">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row g-4">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="display-4 font-family-syne fw-medium">Ready to Elevate Your IT Strategy?</h2>
                    <p>Maecenas nec odio et ante tincidunt tempus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</p>
                    <a class="button button-lg button-radius button-outline-white mt-4" routerLink="/contact">Call Us</a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="row g-4">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <h2 class="display-6 font-family-syne fw-light m-0">Putting Your Business First with Smart, Scalable, and Secure IT Solutions</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-4">
            <div class="col-12 col-md-8">
                <div class="contact-form text-md-end">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input type="text" minlength="2" maxlength="15" class="border-radius"
                                        [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                                        placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_email">Email</label>
                                    <input type="email" minlength="2" maxlength="35"
                                        [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input border-radius"
                                        id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                                        email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button type="submit" name="submit" class="button button-md button-radius button-font-2 button-gradient-4 mt-4" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                    <!-- Submit result -->
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="mb-4">
                    <h6 class="fw-medium m-0 font-family-syne">Phone:</h6>
                    <p>+61 (03) 9414 7288</p>
                </div>
                <div class="mb-4">
                    <h6 class="fw-medium m-0 font-family-syne">Email:</h6>
                    <p>yoursite&#64;domain.com</p>
                </div>
                <div>
                    <h6 class="fw-medium m-0 font-family-syne">Address:</h6>
                    <p>380 St Kilda Road, Sydeny VIC 3004, Australia</p>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->